/**
 * @file Frame.js
 */

import { GenericFrame } from "../components/GenericFrame.tsx";
import { TopContents } from "./TopContents.tsx";
import { HowToDownload } from "./HowToDownload.tsx";
import { Download } from "./Download.tsx";
import { HelpAndSupport } from "./HelpAndSupport.tsx";
import { HowToInstallDeviceDriver } from "./HowToInstallDeviceDriver.tsx";
import { HowToUse } from "./HowToUse.tsx";
import { Terms } from "./Terms.tsx";
import { PrivacyPolicy } from "./PrivacyPolicy.tsx";

function Frame() {
  const navItems = [
    { path: "/gas-log-reader", label: "GasLogReaderトップ" },
    { path: "/gas-log-reader/Terms", label: "利用規約" },
    { path: "/gas-log-reader/PrivacyPolicy", label: "プライバシーポリシー" },
    { path: "/gas-log-reader/HowToDownload", label: "ダウンロード方法" },
    { path: "/gas-log-reader/Download", label: "ダウンロード" },
    {
      path: "/gas-log-reader/HowToInstallDeviceDriver",
      label: "デバイスドライバーインストール方法",
    },
    { path: "/gas-log-reader/HowToUse", label: "GasLogReaderの使い方" },
    { path: "/gas-log-reader/HelpAndSupport", label: "トラブルシューティング" },
  ];

  const trustedUrls = [
    "/gas-log-reader",
    "/gas-log-reader/Terms",
    "/gas-log-reader/PrivacyPolicy",
    "/gas-log-reader/HowToDownload",
    "/gas-log-reader/Download",
    "/gas-log-reader/HelpAndSupport",
    "/gas-log-reader/HowToInstallDeviceDriver",
    "/gas-log-reader/HowToUse",
  ];

  const routes = [
    { path: "/", element: <TopContents /> },
    { path: "/Terms", element: <Terms /> },
    { path: "/PrivacyPolicy", element: <PrivacyPolicy /> },
    { path: "/HowToDownload", element: <HowToDownload /> },
    { path: "/Download", element: <Download /> },
    { path: "/HelpAndSupport", element: <HelpAndSupport /> },
    {
      path: "/HowToInstallDeviceDriver",
      element: <HowToInstallDeviceDriver />,
    },
    { path: "/HowToUse", element: <HowToUse /> },
  ];

  return (
    <GenericFrame
      navItems={navItems}
      trustedUrls={trustedUrls}
      routes={routes}
    />
  );
}

export default Frame;
